import { IconButtonProps } from '../../../IconButton'
import { NavListItem, NavListItemProps } from '../../elements/NavListItem'
import { IconButtons } from './elements/IconButtons'
import * as Styled from './styles'

interface NavListItemWithIconButtonsProps<T> extends NavListItemProps<T> {
  iconButtons: IconButtonProps[]
}

export const NavListItemWithIconButtons = <T,>({ iconButtons, ...rest }: NavListItemWithIconButtonsProps<T>) => {
  return (
    <Styled.NavListItemWithIconButtonsWrapper>
      <NavListItem {...rest}>
        <IconButtons iconButtons={iconButtons} />
      </NavListItem>
    </Styled.NavListItemWithIconButtonsWrapper>
  )
}
